const rawBaseUrl = process.env.REACT_APP_API_URL_CONOPS;

if (!rawBaseUrl) {
  throw new Error("❌REACT_APP_API_URL is not set. Please define it in your .env file.");
}

const baseUrl = rawBaseUrl.endsWith("/") ? rawBaseUrl.slice(0, -1) : rawBaseUrl;
const apiUrlconops = baseUrl.endsWith("/api") ? baseUrl : `${baseUrl}/api`;

export default apiUrlconops;






